import {NavLink, useLocation} from "react-router-dom";
import s from "../../assets/styles/NavBar.module.css";
import {isMinzdravUser, isRoivUser, reportUsersAllowed, SubUser} from "../../services/models/sub_user";
import {Administrator} from "../../services/models/administrator";
import {useFetchUnreadRecom} from "../../hooks/useQuery/useFetchUnreadRecom";
import {useState} from "react";

interface NavBarLoggedInViewProps {
    homeLink: string;
    isAdmin: boolean;
    user?: SubUser | Administrator;
}

const NavBarLoggedInView = ({homeLink, isAdmin, user}: NavBarLoggedInViewProps) => {
    // Проверяем роли пользователя
    const isRoiv = user && !isAdmin ? isRoivUser(user as SubUser) : false;
    const isMinzdrav = user && !isAdmin ? isMinzdravUser(user as SubUser) : false;

    // Доступ к форме отчета для администраторов, пользователей из списка, РОИВ и Минздрава
    const canShowReportForm =
        isAdmin ||
        (!!user &&
            (user as SubUser).id !== undefined &&
            ((reportUsersAllowed.includes((user as SubUser).email) && isRoiv) || isMinzdrav));

    // Доступ к Форме 30 только для администраторов и РОИВ
    const canShowForm30 = isAdmin || isRoiv;

    const {recomData, recomError, recomIsLoading} = useFetchUnreadRecom()
    const [isMonitoringHovered, setIsMonitoringHovered] = useState(false);
    const location = useLocation();

    // Проверяем, находимся ли мы на странице Форма 30
    const isForm30Active = location.pathname.includes('/form30');

    return (
        <div className={s.innerNavbarWrapper}>
            {!isAdmin && (
                <NavLink to={homeLink} end className={({isActive}) => [isActive ? s.navActive : ""].join(" ")}>
                    Главная
                </NavLink>
            )}

            {(canShowReportForm || canShowForm30) && (
                <div
                    className={(canShowReportForm && canShowForm30) ? s.dropdownWrapper : ''}
                    onMouseEnter={() => (canShowReportForm && canShowForm30) && setIsMonitoringHovered(true)}
                    onMouseLeave={() => (canShowReportForm && canShowForm30) && setIsMonitoringHovered(false)}
                >
                    <NavLink
                        to={homeLink + (
                            // Если на странице Форма 30 и есть доступ к ней, показываем её
                            isForm30Active && canShowForm30 ? "/form30" :
                            // Если на странице Проф.осмотры и есть доступ к ним, показываем их
                            !isForm30Active && canShowReportForm ? "/report" :
                            // Иначе показываем то, к чему есть доступ
                            canShowReportForm ? "/report" : "/form30"
                        )}
                        className={({isActive}) => [isActive ? s.navActive : "", isMonitoringHovered ? s.navHovered : ""].join(" ")}
                    >
                        {
                            // Показываем текст в зависимости от того, на какой странице и к чему есть доступ
                            isForm30Active && canShowForm30 ? "Форма 30" :
                            !isForm30Active && canShowReportForm ? "Проф.осмотры" :
                            canShowReportForm ? "Проф.осмотры" : "Форма 30"
                        }
                    </NavLink>
                    {isMonitoringHovered && (canShowReportForm && canShowForm30) && (
                        <div className={s.dropdownMenu}>
                            {/* Если на странице Форма 30, показываем в выпадающем меню Проф.осмотры */}
                            {canShowReportForm && isForm30Active && (
                                <NavLink
                                    to={homeLink + "/report"}
                                    className={({isActive}) => [s.dropdownItem, isActive ? s.dropdownItemActive : ""].join(" ")}
                                >
                                    Проф.осмотры
                                </NavLink>
                            )}
                            {/* Если на странице Проф.осмотры, показываем в выпадающем меню Форму 30 */}
                            {canShowForm30 && !isForm30Active && (
                                <NavLink
                                    to={homeLink + "/form30"}
                                    className={({isActive}) => [s.dropdownItem, isActive ? s.dropdownItemActive : ""].join(" ")}
                                >
                                    Форма 30
                                </NavLink>
                            )}
                        </div>
                    )}
                </div>
            )}
            {!isMinzdrav && (
                <NavLink
                    to={homeLink + (isAdmin ? "/statistics" : "/recommendations")}
                    className={({isActive}) => [isActive ? s.navActive : ""].join(" ")}
                >
                    {isAdmin ? (
                        <span>Статистика</span>
                    ) : (
                        <div className={s.linkInner}>
                            {(!recomError && !recomIsLoading && Number(recomData) > 0) && (
                                <span className={s.unreadCount}>{recomData}</span>
                            )}
                            <span>Рекомендации</span>
                        </div>
                    )}
                </NavLink>
            )}

            {isAdmin && (
                <NavLink
                    to={homeLink + "/recommendations"}
                    className={({isActive}) => [isActive ? s.navActive : ""].join(" ")}
                >
                    <div className={s.linkInner}>
                        {(!recomError && !recomIsLoading && Number(recomData) > 0) && (
                            <span className={s.unreadCount}>{recomData}</span>
                        )}
                        <span>Рекомендации</span>
                    </div>

                </NavLink>
            )}
            <NavLink
                to={homeLink + "/knowledge-base"}
                className={({isActive}) => [isActive ? s.navActive : ""].join(" ")}
            >
                База знаний
            </NavLink>
            {!isMinzdrav && (
                <NavLink to={homeLink + "/feedback"} end
                         className={({isActive}) => [isActive ? s.navActive : ""].join(" ")}>
                    Обратная связь
                </NavLink>
            )}
        </div>
    );
};

export default NavBarLoggedInView;
